export default function initHeaderAnchors() {
  const headers = document.querySelectorAll('h2.single-blog-content-title');

  if (!headers.length) return;

  const baseUrl = window.location.origin + window.location.pathname;

  headers.forEach((header) => {

    let id = header.id;
    if (!id) {
      id = header.textContent
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/\s+/g, '-');
      header.id = id;
    }

    const tooltipText = 'Copy link to this section';

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'header-anchor';
    button.dataset.anchor = id;
    button.setAttribute('aria-label', tooltipText);

    header.appendChild(button);

    button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const url = `${baseUrl}#${id}`;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url)
          .then(() => showCopied(button))
          .catch(() => fallbackCopyTextToClipboard(url, button));
      } else {
        fallbackCopyTextToClipboard(url, button);
      }
    });
  });

  if (window.location.hash) {
    const target = document.querySelector(window.location.hash);
    if (target) {
      setTimeout(() => {
        const offset = 80;
        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: 'smooth' });
      }, 100);
    }
  }

  function showCopied(button) {
    button.classList.add('copied');
    setTimeout(() => button.classList.remove('copied'), 1200);
  }

  function fallbackCopyTextToClipboard(text, button) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.top = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
      showCopied(button);
    } catch (err) {
      console.warn('Clipboard copy failed', err);
    }
    document.body.removeChild(textarea);
  }
}
